import type { ProductRefSlug, ProductSlug } from "~/dto/product";
import type { CategorySlug } from "~/dto/category";

export function productPath(product: ProductSlug): string {
  return `/p/${product.slug}/${product.id}`;
}

export function productPathByRef(product: ProductRefSlug): string {
  return `/p/${product.slug}/r/${product.reference_slug}`;
}

export function categorySlugPath(category: CategorySlug): string {
  return `/c/${category.slug}`;
}